import React, { createContext, PropsWithChildren } from 'react';

import { ILogo } from 'components/shared/ArrayFields/types';
import { IProposal } from 'utils/itineraryDetails/types';
import { IBrandSettings } from 'utils/types';

export interface IPDFDataContext {
  page: IProposal;
  title: IProposal['title'];
  logo?: ILogo['url'];
  travelDates: IProposal['travelDates'];
  preparedFor: IProposal['preparedFor'];
  companyName?: IBrandSettings['companyName'];
  email?: IBrandSettings['email'];
  phone?: IBrandSettings['contactPhone'];
  primaryColor?: IBrandSettings['primaryColor'];
  emergencyContacts: IProposal['emergencyContacts'];
  showImages: boolean;
}

const defaultContextValue: IPDFDataContext = {
  page: {} as IProposal,
  title: '',
  travelDates: '',
  preparedFor: '',
  emergencyContacts: [],
  showImages: false,
};

export const PDFDataContext = createContext<IPDFDataContext>(defaultContextValue);

interface IPDFDataContextProviderProps extends PropsWithChildren {
  data: IProposal;
  showImages: boolean;
}

export function PDFDataContextProvider({ children, data, showImages }: IPDFDataContextProviderProps) {
  const pdfData = getPDFData(data, showImages);

  return <PDFDataContext.Provider value={pdfData}>{children}</PDFDataContext.Provider>;
}

function getPDFData(page: IProposal, showImages: boolean): IPDFDataContext {
  return {
    page,
    title: page.title,
    logo: page.brandSettings?.logo?.url,
    travelDates: page.travelDates,
    preparedFor: page.preparedFor,
    companyName: page.brandSettings?.companyName,
    email: page.brandSettings?.email,
    phone: page.brandSettings?.contactPhone,
    primaryColor: page.brandSettings?.primaryColor,
    emergencyContacts: page.emergencyContacts || [],
    showImages,
  };
}
